import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdRelatedOptionsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioRelatedOptionsQuery = (id: number, enabled = true) =>
	useQuery({
		queryKey: PortfolioKeys.portfolioRelatedOptions(id),
		queryFn: processResponse(() => getPortfolioIdRelatedOptionsV2(id)),
		enabled,
	});
